<section id="app" class="section mobile" aria-labelledby="app-title">
  <div class="container">
    <div class="mobile__card" appReveal>
      <div class="mobile__text">
        <p class="eyebrow">Mobile app</p>
        <h2 id="app-title" class="title">Little Nap, in your <em>pocket</em></h2>
        <p class="lead">Shop the whole range from your phone with the Little Nap app.</p>

        <ul class="stores">
          @for (s of stores; track s.id) {
            <li>
              <!-- a link once the app has a page in that store -->
              <a class="store" [attr.href]="s.href || null" [attr.target]="s.href ? '_blank' : null" [attr.rel]="s.href ? 'noopener' : null">
                @if (s.id === 'apple') {
                  <svg viewBox="0 0 16 19" aria-hidden="true">
                    <path fill="currentColor" d="M13.2 10.05c-.02-2.06 1.68-3.05 1.76-3.1-.96-1.4-2.45-1.6-2.98-1.62-1.27-.13-2.48.75-3.12.75-.64 0-1.63-.73-2.68-.71-1.38.02-2.65.8-3.36 2.04-1.43 2.48-.37 6.15 1.03 8.16.68.98 1.5 2.09 2.57 2.05 1.03-.04 1.42-.67 2.67-.67 1.25 0 1.6.67 2.69.65 1.11-.02 1.81-1 2.49-1.99.78-1.14 1.1-2.24 1.12-2.3-.02-.01-2.15-.83-2.19-3.26zM11.2 3.6c.56-.69.94-1.63.84-2.6-.81.04-1.8.54-2.38 1.22-.52.6-.98 1.57-.86 2.5.9.07 1.83-.46 2.4-1.12z" />
                  </svg>
                } @else {
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="#00d2ff" d="M3.6 2.3c-.3.3-.5.8-.5 1.4v16.6c0 .6.2 1.1.5 1.4l9.3-9.7z" />
                    <path fill="#00f076" d="m12.9 12 3.1-3.2L5 2.5c-.5-.3-1-.3-1.4-.2z" />
                    <path fill="#ff3a44" d="m12.9 12-9.3 9.7c.4.1.9.1 1.4-.2l11-6.3z" />
                    <path fill="#ffd500" d="m16 8.8-3.1 3.2 3.1 3.2 3.8-2.2c1-.6 1-1.5 0-2.1z" />
                  </svg>
                }
                <span>
                  <small>{{ s.caption }}</small>
                  {{ s.name }}
                </span>
              </a>
            </li>
          }
        </ul>
        @if (comingSoon) {
          <p class="mobile__soon">Coming soon to iPhone and Android.</p>
        }

        <div class="pay">
          <p class="pay__label">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M6 10.5h12a1.5 1.5 0 0 1 1.5 1.5v7A1.5 1.5 0 0 1 18 20.5H6A1.5 1.5 0 0 1 4.5 19v-7A1.5 1.5 0 0 1 6 10.5ZM8 10.5V7.8a4 4 0 0 1 8 0v2.7" />
            </svg>
            Pay using
          </p>
          <ul class="pay__list">
            @for (p of payments; track p.name) {
              <li><img [src]="p.image" [alt]="p.name" [width]="p.width" [height]="p.height" loading="lazy" decoding="async" /></li>
            }
          </ul>
        </div>
      </div>

      <!-- an iPhone with this page scrolling by on its screen -->
      <div class="mobile__phone" aria-hidden="true">
        <div class="phone">
          <div class="phone__screen">
            <div class="phone__status">
              <span>9:41</span>
              <span class="phone__island"></span>
              <span class="phone__battery"></span>
            </div>
            <div class="phone__page">
              <img src="assets/misc/app-scroll.webp" alt="" width="585" height="3540" loading="lazy" decoding="async" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
